/**
 * Whether at least one value-set (sector) weight is non-zero.
 *
 * Value-set sliders can be set to 0 to exclude a sector. If every sector is 0
 * the priority area score divides by a total weight of 0 (NaN), so the UI must
 * block applying an all-zero set.
 */
export const hasAnyPositiveWeight = (weights: { [key: string]: number }): boolean =>
  Object.values(weights).some((weight) => weight > 0)
